<template>
  <div>
    <div
      v-dompurify-html="highlightAirport(value)"
      class="airport"
      :class="{ 'is-bt-flight': isBtFlight }"
    />
    <span
      v-if="isBtFlight"
      class="bt-flight"
    >
      {{ $t('searchForm.originDestin.btFlightEHorizon') }}
    </span>
    <div
      v-dompurify-html="highlightCityAndCountry(value)"
      class="country-container"
    />
  </div>
</template>

<script>
  import OriginItem from 'components/eHorizon/Destination/OriginItem'

  export default {
    extends: OriginItem,
    props: {
      touched: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      isBtFlight() {
        return this.value.hasBTDirect && !this.touched
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/mixins.scss';

  .is-bt-flight {
    @include bp-mf-tablet() {
      max-width: 190px;
    }

    @include bp-mf-desktop() {
      max-width: 210px;
    }
  }
</style>
